import Nullstack from 'nullstack';
export default function IconLifebuoyOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-lifebuoy-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9.171 9.172a4 4 0 0 0 5.65 5.663m1.179 -2.835a4 4 0 0 0 -4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M5.64 5.632a9 9 0 1 0 12.73 12.725m1.667 -2.301a9 9 0 0 0 -12.077 -12.1"
  }), "   ", Nullstack.element("path", {
    d: "M15 15l3.35 3.35"
  }), "   ", Nullstack.element("path", {
    d: "M9 15l-3.35 3.35"
  }), "   ", Nullstack.element("path", {
    d: "M5.65 5.65l3.35 3.35"
  }), "   ", Nullstack.element("path", {
    d: "M18.35 5.65l-3.35 3.35"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}